import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

// import Informasi from "./Informasi";
// import Banksaal from "./Banksaal";
// import MediaBelajar from "./MediaBelajar";
// import Testtoefi from "./Testtoefi";
// import Sertifikasi from "./Sertifikasi";
// import Komplain from "./Komplain";
// import Forum from "./Forum";
// import Pengaturan from "./Pengaturan";

const Dashboard = () => {
  return (
    <div>
      <div class="container">
        {/* <Router>
          <Routes>
            <Route exact path="/Header" element={} />
            <Route exact path="/Banksaal" element={<Banksaal />} />
            <Route exact path="/MediaBelajar" element={<MediaBelajar />} />
            <Route exact path="/Informasi" element={<Informasi />} />
            <Route exact path="/Testtoefi" element={<Testtoefi />} />
            <Route exact path="/Sertifikasi" element={<Sertifikasi />} />
            <Route exact path="/Komplain" element={<Komplain />} />
            <Route exact path="/Forum" element={<Forum />} />
            <Route exact path="/Pengaturan" element={<Pengaturan />} />
          </Routes>
        </Router> */}
        <Sidebar />
        <Header />
        
      </div>
    </div>
  );
};

export default Dashboard;
